import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import {
  AE_CARD,
  AE_MUTED,
  AE_PUBLIC_PAGE,
  AE_TITLE,
} from '@/components/assessment-engine/layout/aeTheme';
import { assessmentEngineService } from '@/services/assessmentEngineService';

/**
 * Public page opened from invite/reminder email unsubscribe links.
 * Uses FRONTEND_URL in emails so recipients never see the API host/port.
 */
export const InviteUnsubscribePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useLanguage();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      try {
        await assessmentEngineService.unsubscribeInvite(token);
        if (!cancelled) setStatus('ok');
      } catch {
        if (!cancelled) setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main className={AE_PUBLIC_PAGE}>
      <div className={`${AE_CARD} max-w-md mx-auto mt-16 p-6`}>
        {status === 'loading' && <p className={AE_MUTED}>…</p>}
        {status === 'ok' && (
          <>
            <h1 className={AE_TITLE}>{t('assessmentEngine.public.inviteUnsubscribedTitle')}</h1>
            <p className={`mt-3 ${AE_MUTED}`}>{t('assessmentEngine.public.inviteUnsubscribedBody')}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className={AE_TITLE}>{t('assessmentEngine.public.inviteUnsubscribeFailedTitle')}</h1>
            <p className={`mt-3 ${AE_MUTED}`}>{t('assessmentEngine.public.inviteUnsubscribeFailedBody')}</p>
          </>
        )}
      </div>
    </main>
  );
};
